module.exports = __webpack_public_path__ + "media/机器人实操基地14.cbfd370c.mp4";